<template>
  <label
    class="radio-button">
    <input
      class="radio-button__input"
      type="radio"
      :name="name"
      :value="value"
      @input="toggleChecked" />
    <div
      class="radio-button__checkmark"
      :class="{
        'radio-button__checkmark--checked': checked,
        'radio-button__checkmark--disabled': disabled,
      }" />
  </label>
</template>

<script>
export default {
  name: "RadioButton",
  data() {
    return {
    };
  },
  props: {
    value: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    toggleChecked(e) {
      if(!this.disabled) {
        this.$emit("input", this.value, !this.checked);
      }
    }
  }
}
</script>

<style lang="scss">
.radio-button {
  position: relative;
  height: 14px;
  width: 14px;

  cursor: pointer;

  &__input {
    width: 0;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  &__checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 14px;
    width: 14px;

    border: $px1 solid $grey-8;
    border-radius: 50%;

    background-color: $white;

    &:hover {
      border-color: $grey-7;
    }

    &:after {
      content: "";
      position: absolute;
      display: none;
    }

    &--checked {
      border-color: $blue-6;

      &:hover {
        border-color: $blue-5;
      }

      &:after {
        display: block;
        left: 50%;
        top: 50%;
        width: $px8;
        height: $px8;

        border: 0;
        border-radius: 50%;

        background-color: $blue-5;

        transform: translate(-50%, -50%);
      }
    }

    &--disabled {
      border-color: $grey-8;

      background-color: $grey-9;

      &:hover {
        border-color: $grey-8;

        background-color: $grey-9;
      }
    }
  }
}
</style>
